module.exports = __webpack_public_path__ + "WU.svg?51827e81feb1101dd8933a55bbd792cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/WU.svg
// module id = 77
// module chunks = 0